import React, { Component } from 'react';
import { Redirect,Link } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Form from "react-jsonschema-form";
import CKEditor from "react-ckeditor-component";
import $ from 'jquery';
const schema = {}
const uiSchema ={}
class Updateokr extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {},
            errors: {},
            message: '',
            loading: false,
            formData: {},
            form: false,
            schema:schema,
            uiSchema:uiSchema,
            formData:'',
            fields: {},
            update: 0,
            notes: [],
            note: '',
            snippet_history: [],
            formatted_owners: [],
            owners:[],
            scrol: 1
           
       }
       this.submitUser = this.submitUser.bind(this);
       this.AddNote = this.AddNote.bind(this);
       this.ckOnChange1 = this.ckOnChange1.bind(this);
   }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    submitUser(data) {
        data.formData.objective_id = this.props.match.params.id;
        let api_url = this.state.apiUrl + '/OkrRest/updateuser/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId;
        this.state.fields['formData'] = data.formData;
        document.getElementById("add_user_btn").disabled = true;
        fetch(api_url, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state.fields),
        })
                .then((response) => response.json())
                .then((result) => {
                    result = this.decrypt(result, 1);
                    if (result.code === 200) {
                        document.getElementById("add_user_btn").disabled = true;
                        this.props.history.push('/listokr');
                    } else {
                        this.setState({
                            error_message: result.msg,
                            formData: data.formData
                        });
                        document.getElementById("add_user_btn").disabled = false;
                    }
                })
        return false;
    }
    isSet(iVal){
        console.log(iVal);
        return (iVal!=="" && iVal!=null && iVal!==undefined && typeof(iVal) != "undefined") ? 1 : 0;
    } 
    ManageDynamicform() {
        this.setState({
                loading:true
        });
        fetch(this.state.apiUrl + '/OkrRest/ManageForm/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId+ '/objectId/' + this.props.match.params.id,{
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
       .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            //console.log(findresponse.form['schema']);
            this.setState({
                schema:findresponse.form['schema'],
                uiSchema:findresponse.form['uiSchema']
            });
        })
    }

    ckOnChange1(evt) {
        var ckContent = evt.editor.getData();
        if (this.state.note.toLowerCase() != ckContent.toLowerCase()) {
            this.setState({
                note: ckContent
            })
            var obj = this;
            setTimeout(function () {
                ckContent = ckContent.replace(/<\/p>$/, ""); //remove last </p>
                var nameRegex = /@[a-zA-Z]+$/;
                var matches = ckContent.match(nameRegex); //select characters having @
                if (matches && matches.length > 0) {
                    var indx = matches['index'];
                    var query = matches[0].replace('@', '');
                    if (query) {
                        var result = [];
                        var filterObj = obj.state.owners.filter(function (e) {
                            if (e.name.toLowerCase().includes(query.toLowerCase())) {
                                result.push(e.name);
                            }
                        });
                        var mtchitems = '';
                        if (result.length > 0) {
                            for (var i in result) {
                                mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" >' + result[i] + '</li>';
                                if (i == result.length - 1) {
                                    mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';
                                    document.getElementById('note_autoseggestion').innerHTML = mtchitems;
                                    $('.auto-suggest-li').on('click', function (event) {
                                        var final_string = ckContent.substring(0, indx) + "@" + event.target.innerText.trim();
                                        evt.editor.setData(final_string);
                                        obj.setState({
                                            note: final_string,
                                        })

                                        document.getElementById('note_autoseggestion').innerHTML = "";
                                        evt.editor.focus();
                                    });
                                }
                            }
                        } else {
                            document.getElementById('note_autoseggestion').innerHTML = "";
                        }
                    }
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            }, 300);
        } else {
            evt.editor.focus();
        }
    }
    ManageNotehistory() {
        this.setState({
                loading:true
        });
        fetch(this.state.apiUrl + '/OkrRest/GetNoteHistory/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId+ '/objectId/' + this.props.match.params.id,{
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
       .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            //console.log(findresponse.form['schema']);
            this.setState({
                snippet_history:findresponse.snippet_history,
                formatted_owners:findresponse.formatted_owners,
                owners: findresponse.owners,
                notes:findresponse.notes
            });
        })
    }
    AddNote() {
        let errors = {};
        document.getElementById("add_note").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("add_note").disabled = true;
        fd.append('note', this.state.note);
        fd.append('object_id', this.props.match.params.id);
        fetch(this.state.apiUrl + '/OkrRest/AddOkrNote/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        errors["note"] = "";
                        this.setState({ errors: errors, note: '' });
                        // this.getSnippetDetails();
                        window.location.href = '/updateokr/' + this.props.match.params.id;
                    });
                } else {
                    errors["note"] = findresponse.msg;
                    this.setState({ errors: errors });
                    this.setState({ message: findresponse.msg })
                }
            })
    }
    getTattleAttributeDetails(objectid) {
        this.state.fields['objective_id'] = objectid;
        document.getElementById("add_user_btn").disabled = true;
        fetch(this.state.apiUrl + '/OkrRest/getdetails/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId,{
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state.fields),
        })
                .then((response) => response.json())
                .then((result) => {
                    result = this.decrypt(result, 1);
                    console.log(result.data);
                    if (result.code === 200) {
                        this.setState({
                            formData: result.data,
                            scrol: this.state.scrol + 1
                        });
                        document.getElementById("add_user_btn").disabled = false;
                    } else {
                        this.setState({
                            message_type: 'danger',
                            message: result.msg
                        });
                    }

                    if(this.state.scrol <= 2)
            {

            const { location:{ pathname, hash}} = this.props;
            const element = document.getElementById(hash.replace("#",""));

            setTimeout( () => {
                window.scrollTo({
                    behavior: element ? "smooth" : 'auto',
                    top: element ? element.offsetTop : 0
                })
            })
        }
        else
        {
            return false;
        }
                })
    }
    getHistoryTitle(type, old_value, new_value) {
        if (type == 1) {
            return 'Okr Added'
        } else if (type == 2) {
            return ('Okr Updated')
        } else if (type == 3) {
            return ('Note Added : ' + new_value)
        } else if (type == 4) {
            return ('Note Updated : ' + old_value)
        } else if (type == 5) {
            return ('Okr Deleted')
        }
    }
    getHistoryDesc(type, old_value, new_value) {
        if (type == 1) {
            return ''
        } else if (type == 2) {
            return ''
        } else if (type == 3) {
           // return old_value + ' => ' + new_value
           return ''
        } else if (type == 4) {
            return (
                <Link to={`/okrhistoryrevision/${this.props.match.params.id}/noteId/${old_value}`} name={"max"} target="_blank"><span className="color-sky">View Revision</span></Link>
            )
        }
    }
    NoteEditCondition(id, note) {
        return (
            <a href="javascript:void(0)" onClick={() => this.setNote(id, note)}> <i class="fa fa-edit"></i></a>
        )
    }

    setNote(id, note) {
        localStorage.setItem('ticket_note', note);
        this.props.history.push('/noteokredit/' + id);
    }
     componentDidMount() {
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
         document.title = "Intranet | Update OKR";
        this.getTattleAttributeDetails(this.props.match.params.id);
        this.ManageDynamicform();
        this.ManageNotehistory();
        
   }
   goBack() {
    window.location.href = '/listokr';
    //window.history.back();
}
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
       return (
            <div>
                <Header brecum_name="ER" brecum_page="OKR" />
                <div class="right_col">
                    <div class="intranet_body col-md-12">
                        <div class="title mob"><HeaderMob page_name="Update OKR" /></div>
                        <div class="form-group"></div>
                        <div class="top-row-form">
                          <div class="form-group">
                          {this.state.error_message ? (<div className="alert alert-danger">{this.state.error_message}</div>) : ''}
                                 <Form
                                    formData={this.state.formData}
                                    schema={this.state.schema}
                                    uiSchema={this.state.uiSchema}
                                    liveValidate={false}
                                    showErrorList={false}
                                    onSubmit={this.submitUser}
                                    noHtml5Validate={true} 
                                  >
                                    <button type="submit" id="add_user_btn" className="btn btn-primary">{this.state.update > 0 ? 'Update Okr'  : 'Update Okr'}</button>
                                </Form>
                        </div>
                        </div>
                       
                        <div class="request_details col-md-9">                        
                            <div id="exTab1">
                                <ul class="nav nav-pills">
                                    <li class="active"><a href="#note" data-toggle="tab">Notes</a></li>
                                    <li><a href="#history" data-toggle="tab">History</a></li>
                                </ul>
                    </div>
                            <div class="tab-content customer-tab clearfix ">
                                <div className="tab-pane active" id="note">
                                    <div class="row">
                                        <div className="form-section ckeditor">
                                            <CKEditor
                                                activeClass="p10"
                                                name='note'
                                                content={this.state.note}
                                                events={{
                                                    "change": this.ckOnChange1
                                                }}
                                            />
                                            <div id='note_autoseggestion'></div>
                                            <span class="error">{this.state.errors["note"]}</span>
                </div>
                                        <div className="form-section ckeditor">
                                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.AddNote()}>Add Note</button>
                                        <button type="button" className="btn btn-blue hidden-sm" onClick={() => this.goBack()} >Back</button>
            </div>
                                    </div>
                                    <div className="feedback">
                                        {this.state.notes.length > 0 ?
                                            <h5 class="title"><span>View Note</span></h5>
                                            : ''}
                                        {
                                            this.state.notes.map((data, key) =>
                                                <div class="sub_feedback" id={'note' + data.id}>
                                                    <div class="main">
                                                        <div class="pro_image">
                                                            {this.state.formatted_owners[data.user_id].attachment_url ? <img src={this.state.formatted_owners[data.user_id].attachment_url + this.state.formatted_owners[data.user_id].attachment} /> : <span class="profile_first_name">{this.state.formatted_owners[data.user_id].img_name}</span>}
                                                        </div>
                                                        <div class="fa-icon tooltips">
                                                        {this.NoteEditCondition(data.id, data.note)}
                                                        </div>
                                                    <h6><Link to={`/viewEmployee/${data.user_id}`} name={"max"}>{data.owner_name}</Link></h6>
                                                        <span class="date">{data.created_date}</span>
                                                    </div>
                                                    <div class="sub">
                                                        <a href={'#note' + data.id} key={key} to={data.id} name={"max"}><span>Note {data.id}</span></a>
                                                        <div class="note_list" dangerouslySetInnerHTML={{ __html: data.note }} />
                                                    </div>
                                                </div>
        )
    }
                                    </div>
                                </div>
                                <div class="tickets tab-pane " id="history">
                                    <div className="feedback">
                                        {this.state.snippet_history.length > 0 ?
                                            <h5 class="title"><span>Okr History</span></h5>
                                            : ''}
                                        <ul class="tickets_head">
                                            <li class="intra_col_25">Date</li>
                                            <li class="intra_col_25">User</li>
                                            <li class="intra_col_25">Field</li>
                                            <li class="intra_col_25">Change</li>
                                        </ul>
                                        {
                                            this.state.snippet_history.map((ErHistory, key) =>
                                                <ul class="tickets_number">
                                                <li class="intra_col_25">{ErHistory.date_modified} </li>
                                                    <li class="intra_col_25"><Link to={`/viewEmployee/${ErHistory.user_id}`} name={"max"}>{this.state.formatted_owners[ErHistory.user_id].name}</Link></li>
                                                    <li class="intra_col_25">{this.getHistoryTitle(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                    <li class="intra_col_25">{this.getHistoryDesc(ErHistory.type, ErHistory.old_value, ErHistory.new_value)}</li>
                                                </ul>
                                            )
}
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        )
    }
}
export default Updateokr;



// WEBPACK FOOTER //
// ./src/components/okr/updateokr.js